import { z } from 'zod';

const additionalFieldSchema = z.object({
  type: z.enum(['text', 'url', 'email', 'date', 'password', 'phone', 'note']),
  value: z.string().trim().min(1, 'This field is required'),
});

const loginFormSchema = z.object({
  name: z.string().trim().min(1, 'Credential name is required'),
  providerName: z.string().trim().min(1, 'Provider is required'),
  username: z.string().trim().min(1, 'Username is required'),
  password: z.string().trim().min(1, 'Password is required'),
  url: z.string().trim().min(1, 'Instance URL is required'),
  description: z.string().trim().min(1, 'Description is required'),
  additionalFields: z.array(additionalFieldSchema).default([]),
});

type ILoginForm = z.infer<typeof loginFormSchema>;

const cryptographicKeyFormSchema = z.object({
  name: z.string().trim().min(1, 'Credential name is required'),
  providerName: z.string().trim().min(1, 'Provider is required'),
  key: z.string().trim().min(1, 'Key is required'),
  description: z.string().trim().min(1, 'Description is required'),
  additionalFields: z.array(additionalFieldSchema).default([]),
});

type ICryptographicKeyForm = z.infer<typeof cryptographicKeyFormSchema>;

const apiCredentialsFormSchema = z
  .object({
    name: z.string().trim().min(1, 'Credential name is required'),
    providerName: z.string().trim().min(1, 'Provider is required'),
    secret: z.string().trim().min(1, 'Secret is required'),
    type: z.string().min(1, 'Type is required'),
    otherType: z.string().optional(),
    url: z.string().trim().min(1, 'Instance URL is required'),
    description: z.string().trim().min(1, 'Description is required'),
    additionalFields: z.array(additionalFieldSchema).default([]),
  })
  .refine((data) => data.type !== 'other' || Boolean(data.otherType?.trim()), {
    message: 'Type is required',
    path: ['otherType'],
  });

type IApiCredentialsForm = z.infer<typeof apiCredentialsFormSchema>;

export {
  loginFormSchema,
  type ILoginForm,
  cryptographicKeyFormSchema,
  type ICryptographicKeyForm,
  apiCredentialsFormSchema,
  type IApiCredentialsForm,
};
